import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top
  }, []);

  return (
    <Container className="my-5">
      <Row>
        <Col className="privacyPolicy p-4 bg-white shadow rounded">
          <h2 className="mb-4 text-center">Privacy Policy</h2>

          <p>
            <b>Janu's Food Products</b> ("Company" or "We") respects your
            privacy and is committed to protecting it through our compliance
            with this policy.
          </p>

          <p>
            This policy describes the types of information we may collect from
            you or that you may provide when you visit the website located at{" "}
            <b>https://janusfoodproducts.com</b> or any mobile application or
            social media site operated by the Company (collectively, our
            "Website") and our practices for collecting, using, maintaining,
            protecting, and disclosing that information.
          </p>

          {/* Scope */}
          <h4 className="mt-4">Scope of this Policy</h4>
          <ul>
            <li>On this Website.</li>
            <li>
              In email, text, and other electronic messages between you and this
              Website.
            </li>
            <li>
              Through mobile and desktop applications you download from this
              Website, which provide dedicated non-browser-based interaction
              between you and this Website, if any.
            </li>
            <li>
              When you interact with our advertising and applications on
              third-party websites, applications, and services, such as our
              Facebook page.
            </li>
          </ul>
          <p>
            It does <b>not</b> apply to information collected by us offline or
            through any other means, including on any other website operated by
            the Company or any third party (including our affiliates and
            subsidiaries), except as otherwise expressly set forth herein.
          </p>
          <p>
            By accessing or using this Website, you agree to this Privacy
            Policy. If you do not agree, please do not use our Website. This
            policy may change from time to time, and your continued use means
            you accept those changes.
          </p>

          {/* Usage */}
          <h4 className="mt-4">How We Use Your Information</h4>
          <ul>
            <li>
              <b>Marketing Emails:</b> Used to send newsletters, surveys,
              product updates, and promotional offers. You can unsubscribe at
              any time.
            </li>
            <li>
              <b>Text Messages / WhatsApp:</b> You may receive alerts about
              products, offers, or promotions. No charges from us, but your
              service provider may apply fees.
            </li>
            <li>
              <b>Telephone Calls:</b> We may contact you with product info,
              promotions, or customer service follow-ups.
            </li>
            <li>
              <b>Service Communications:</b> Includes registration confirmation,
              order updates, and responses to queries.
            </li>
            <li>
              <b>Customised Service:</b> Suggestions based on your preferences.
            </li>
            <li>
              <b>Events & Surveys:</b> Information collected during contests,
              surveys, or promotions.
            </li>
            <li>
              <b>Employment:</b> Information such as resumes will be treated
              confidentially and used only for recruitment purposes.
            </li>
          </ul>

          {/* Payments */}
          <h4 className="mt-4">Payments</h4>
          <p>
            <b>Janu's Food Products</b> does <b>not</b> collect or store
            Credit/Debit Card or banking information. Such details are processed
            directly by our secure payment gateway provider.
          </p>

          {/* Security */}
          <h4 className="mt-4">Security</h4>
          <p>
            We use physical, electronic, and managerial safeguards to protect
            your data. Financial transactions are protected using{" "}
            <b>SSL (Secure Sockets Layer) encryption</b>.
          </p>

          {/* Legal */}
          <h4 className="mt-4">Legal Compliance</h4>
          <p>
            We may disclose information if required by law, government request,
            or to protect rights, property, or safety.
          </p>

          {/* Cookies */}
          <h4 className="mt-4">Cookies</h4>
          <p>
            Our Website uses cookies to store preferences and provide a better
            browsing experience. You may disable cookies in your browser, but
            some features may not work properly.
          </p>

          {/* Updates */}
          <h4 className="mt-4">Updates to Policy</h4>
          <p>
            This Privacy Policy may be revised occasionally. Updates will be
            posted here.
          </p>

          {/* Contact */}
          <h4 className="mt-4">Comments / Contact</h4>
          <p>
            For questions or concerns about this Privacy Policy, please contact
            us at: <b>Janusfoodproducts009@gmail.com</b>
          </p>

          {/* Social Media */}
          <h4 className="mt-4">Social Media Notice</h4>
          <p>
            Our Website may include links to our <b>Facebook</b> or{" "}
            <b>Instagram</b> pages. If you click these links while logged into
            your social media account, your visit may be associated with your
            profile. To avoid this, please log out of those services before
            visiting our Website.
          </p>
        </Col>
      </Row>
    </Container>
  );
};
